
import {
  getNodeTypeFromBase64Id,
  runQueryWithVariables
} from '../'

import {
  NODES
} from '../../constants'


export const isNumeric = (n) => (
  !isNaN(parseFloat(n)) && isFinite(n)
)

export const isPositiveNumeric = (n) => {
  let isPositive = [ -0, 0, 1 ].indexOf(Math.sign(n)) > -1

  if (isPositive) {
    return isNumeric(n)
  } else {
    return false
  }
}

export const isNegativeNumeric = (n) => {
  let isNegative = Math.sign(n) === -1

  if (isNegative) {
    return isNumeric(n)
  } else {
    return false
  }
}

export const isNumberInput = (n) => {
  // is input is a string and a valid number (can be float)
  let floatRegExp = /^[-]?\d+(\.\d+)?$/  // matches valid number
  if (typeof n !== "string") {
    return false
  } else if (floatRegExp.test(n) === false) {
    return false
  }

  return isNumeric(n)
}

export const isPositiveNumberInput = (n) => {
  // is input is a string and a valid positive number (can be float)
  let floatRegExp = /^\d+(\.\d+)?$/  // matches valid number
  if (typeof n !== "string") {
    return false
  } else if (floatRegExp.test(n) === false) {
    return false
  }

  return isPositiveNumeric(n)
}

export const isNegativeNumberInput = (n) => {
  // is input is a string and a valid negative number (can be float)
  let floatRegExp = /^[-]+\d+(\.\d+)?$/  // matches valid number
  if (typeof n !== "string") {
    return false
  } else if (floatRegExp.test(n) === false) {
    return false
  }

  return isNegativeNumeric(n)
}

// the function below relies on constant NODES as defined in constants.js
// if,getContextIdFromNodeQuery parameter has value of boolean true, a promise will be returned
// if getContextIdFromNodeQuery false, a string url value will be returned
export const getNodeUrl = (objectId, getContextIdFromNodeQuery = false, contextId) => {
  let nodeType = null

  if (getContextIdFromNodeQuery) {
    try {
      nodeType = getNodeTypeFromBase64Id(objectId)
    } catch (error) {
      return Promise.reject(error)
    }

    const query = NODES[nodeType]
      ? NODES[nodeType].query
      : null

    if (query === null) {
      return Promise.reject('Node type not defined.')
    }

    const variables = { id: objectId }
    return runQueryWithVariables(query, variables)  // runs node type associated query
      .then(({ data }) => {
        let contextNodeType = data.object.context
          ? getNodeTypeFromBase64Id(data.object.context.id)
          : null

        const contextId = contextNodeType === 'ClientNode'
          ? data.object.context.identity.id
          : contextNodeType === 'IdentityNode'
            ? data.object.context.id
            : null

        // if context node type is client, override by changing type to match contextId
        if (contextNodeType === 'ClientNode') {
          contextNodeType = 'IdentityNode'
        }

        const base = contextNodeType
          ? `${NODES[contextNodeType].base}${NODES[contextNodeType].endpoint}/${contextId}`
          : `${NODES[nodeType].base}`

        return `${base}${NODES[nodeType].endpoint}/${objectId}`
      })
  } else {
    nodeType = getNodeTypeFromBase64Id(objectId)

    const contextNodeType = contextId
      ? getNodeTypeFromBase64Id(contextId)
      : null

    const base = contextId
      ? `${NODES[contextNodeType].base}${NODES[contextNodeType].endpoint}/${contextId}`
      : `${NODES[nodeType].base}`

    return `${base}${NODES[nodeType].endpoint}/${objectId}`
  }
}

 export const getNodeTypeFromContentTypeModel = (contentTypeModel) => (
  Object.keys(NODES).find(key => NODES[key].contentTypeModel === contentTypeModel)
)

export const getObjectWithArrayValuesAsArraysOfObjects = (objectWithArrayValues) => {
  if (Array.isArray(objectWithArrayValues) || typeof objectWithArrayValues !== 'object') {
    throw new Error('Invalid input parameter; need to be an object.')
  }
  let arraysOfObjects = []
  let entries = Object.entries(objectWithArrayValues)
  if (entries.length > 0) {
    entries.forEach(([name, value]) => {
      let arrayWithName = Object.assign({ 'name': name }, value)
      arraysOfObjects.push(arrayWithName)
    })
  }
  return arraysOfObjects
}

export const getHealthLevelName = (healthLevel) => (
  {
    0: 'No EarnBacks membership',
    1: 'Bronze',
    2: 'Silver',
    4: 'Gold'
  }[healthLevel]
)



// WEBPACK FOOTER //
// ./src/utils/misc/index.js